"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dictionary = {
  'Public transportation': {
    is: 'Almenningssamgöngur',
    'en-us': 'Public transportation'
  },
  'Opening hours': {
    is: 'Opnunartími',
    'en-us': 'Opening hours'
  },
  'Read more': {
    is: 'Lesa meira',
    'en-us': 'Read more'
  },
  Open: {
    is: 'Í gangi',
    'en-us': 'Current'
  },
  Exhibitions: {
    is: 'Sýningar',
    'en-us': 'Exhibitions'
  },
  'Group exhibition': {
    is: 'Samsýning',
    'en-us': 'Group exhibition'
  },
  Events: {
    is: 'Viðburðir',
    'en-us': 'Events'
  },
  'Upcoming exhibition': {
    is: 'Næsta sýning',
    'en-us': 'Upcoming exhibition'
  },
  News: {
    is: 'Fréttir',
    'en-us': 'News'
  },
  page: {
    is: 'Síða',
    'en-us': 'Page'
  },
  event: {
    is: 'Viðburður',
    'en-us': 'Event'
  },
  exhibition: {
    is: 'Sýning',
    'en-us': 'Exhibition'
  }
};
exports.default = dictionary;